// components/DocumentTitle.js
import React from 'react';
import { Typography, Box } from '@mui/material';

export default function DocumentTitle({ authors, title, fallback }) {
  if (authors?.length && title) {
    return (
      <Box>
        <Typography
          variant="subtitle2"
          component="div"
          color="text.secondary"
          noWrap
        >
          {authors.join(', ')}
        </Typography>
        <Typography
          variant="h6"
          component="div"
          fontWeight="bold"
          gutterBottom
        >
          {title}
        </Typography>
      </Box>
    );
  }

  return (
    <Typography variant="h6" component="div" fontWeight="bold" gutterBottom>
      {fallback}
    </Typography>
  );
}
